/**
 * Export all public constructs under this namespace.
 */

export * from "./getConfig";
export * from "./getElement";
export * from "./getPage";
export * from "./getPortals";
export * from "./getWordDefinition";
